package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model

enum class RoleMessageEnum(val role: String) {
    SYSTEM("system"),
    ASSISTANT("assistant"),
    USER("user")
}
